import React from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

const AdvtFullSize = React.memo(() => {
  const { sizeQR, qrCode1, qrCode2 } = useGetParams();

  return (
    <div className={styles.wrapper}>
      {(qrCode1 || qrCode2) && (
        <div className={styles.qrBlock}>
          {qrCode1 && (
            <motion.div
              className={styles.qrCode}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.33 }}
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode1} alt="qrCode1" />
            </motion.div>
          )}

          {qrCode2 && (
            <motion.div
              className={styles.qrCode}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.33 }}
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode2} alt="qrCode1" />
            </motion.div>
          )}
        </div>
      )}
    </div>
  );
});

export default AdvtFullSize;
